import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lowercaseCustom'
})
export class LowercaseCustomPipe implements PipeTransform {

  transform(value: string): string {
    return value ? value.toLowerCase() : '';
  }

}
